import Image from "mui-image";
import Google_Ads_logo from "Assets/Images/ThirdParty/Google_Ads_logo.png";
import Bing from "Assets/Images/ThirdParty/bing.png";
import Facebook from "Assets/Images/ThirdParty/facebook.png";
import Instagram from "Assets/Images/ThirdParty/instagram.png";
import Twitter from "Assets/Images/ThirdParty/twitter.png";
import Reddit from "Assets/Images/ThirdParty/reddit.png";
import Linkdin from "Assets/Images/ThirdParty/linkedin.png";
import Youtube from "Assets/Images/ThirdParty/youtube.png";
import Tiktok from "Assets/Images/ThirdParty/tiktok.png";
import Postscript from "Assets/Images/ThirdParty/postscript.jpeg";
import Unknown from "Assets/Images/ThirdParty/unknown.png";
import Meta from "Assets/Images/ThirdParty/meta.png";
import { motion } from "motion/react";
import { useMemo } from "react";
import { Box } from "@mui/material";

interface IProviderIconProps {
  provider: string;
  position?: "left" | "center" | "right";
  size?: number;
  rounded?: boolean;
  catchAll?: React.ReactNode;
}

function ProviderIcon({ provider, position = "left", size = 20, rounded = false, catchAll }: IProviderIconProps) {
  const logo = useMemo(() => {
    switch (provider.toLowerCase()) {
      case "google":
        return Google_Ads_logo;
      case "bing":
        return Bing;
      case "facebook":
      case "www.facebook.com":
      case "facebook.com":
        return Facebook;
      case "instagram":
      case "l.instagram.com":
      case "www.instagram.com":
      case "instagram.com":
        return Instagram;
      case "x":
      case "twitter":
      case "www.twitter.com":
      case "twitter.com":
        return Twitter;
      case "reddit":
      case "www.reddit.com":
      case "reddit.com":
      case "com.reddit.frontpage":
        return Reddit;
      case "linkedin":
      case "www.linkedin.com":
      case "linkedin.com":
        return Linkdin;
      case "audience_network":
        return Meta;
      case "youtube":
      case "www.youtube.com":
      case "youtube.com":
        return Youtube;
      case "tiktok":
      case "www.tiktok.com":
      case "tiktok.com":
        return Tiktok;
      case "postscript":
      case "www.postscript.com":
      case "postscript.com":
        return Postscript;

      default: return null
    }
  }, [provider]);


  return (
    <Box
      sx={{ width: size }}
      component={motion.div}
      initial={{
        opacity: 0,
        scale: 0,
      }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
    >
      {logo || !catchAll ? (
        <Image
          height={size}
          src={logo || Unknown}
          duration={50}
          fit={"contain"}
          objectPosition={position}
          sx={{ objectPosition: position, borderRadius: rounded ? "50%" : "0px" }}
        />
      ) : (
        catchAll
      )}
    </Box>
  );
}

export default ProviderIcon;
